<template>
    <div class="v2-retailer-cart__brand-product" @click="/*goToProduct()*/">
        <router-link
            :to="`/account/catalog/product/${product.ItemID}`"
            class="v2-retailer-cart__brand-product-logo"
        >
            <img
                :src="product.images.length ? product.images[0].url : null"
                alt=""
                class="v2-retailer-cart__brand-product-img ofi"
            />
        </router-link>
        <div class="v2-retailer-cart__brand-product-descr">
            <div class="v2-retailer-cart__brand-product-descr-left">
                <div class="v2-retailer-cart__brand-product-brand">
                    {{ product.brand.BrandName }}
                </div>
                <div class="v2-retailer-cart__brand-product-text">
                    {{ product.type.Name }}
                </div>
                <div
                    class="v2-retailer-cart__brand-product-text v2-retailer-cart__brand-product-text--gray mb-2"
                >
                    Арт. {{ product.Article }}
                </div>
                <div class="v2-retailer-cart__brand-product-text">
                    {{ getFormattedNum(product.Price || 0) }} Р/
                    {{
                        getNameById(
                            priceUnitOptions,
                            'abbr',
                            'id',
                            product.PriceUnit
                        )
                    }}
                </div>
            </div>
            <div class="v2-retailer-cart__brand-product-descr-right">
                <div class="v2-retailer-cart__brand-product-addtocart">
                    <div
                        class="cabinet__catalog-form_minus"
                        @click="decreaseQuantityInCart"
                    ></div>
                    <input
                        :value="quantity"
                        type="text"
                        class="cabinet__catalog-form_input cabinet-form-group__input"
                        @click.stop=""
                        @change="onInCartQuantityInput"
                    />
                    <div
                        class="cabinet__catalog-form_plus"
                        @click="increaseQuantityInCart"
                    ></div>
                </div>
                <div class="v2-retailer-cart__brand-product-summary">
                    {{ getFormattedNum(product.Price * quantity || 0) }}
                    Р
                </div>
            </div>

            <div class="v2-retailer-cart__brand-product-descr-bottom">
                <div
                    v-if="isCommentOpen"
                    class="cabinet-form-group mt-0 mb-md-3"
                >
                    <label class="cabinet-form-group__label" for="message"
                        >Комментарий</label
                    >
                    <textarea
                        id="message"
                        v-model="comment"
                        class="cabinet-form-group__textarea cabinet-form-group__textarea--resizable v2-retailer-cart__brand-product-textarea"
                        @input="changeCartInfo"
                        @click.stop=""
                    ></textarea>
                    <div
                        class="cabinet-form-group__textarea-chars js-chars-count"
                    >
                        <span>{{ comment ? comment.length : 0 }}</span
                        >/255
                    </div>
                </div>
                <a
                    v-else
                    href="javascript:void(0)"
                    class="v2-retailer-cart__brand-product-link"
                    @click.prevent="openComment"
                    >Добавить комментарий</a
                >
                <a
                    href="javascript:void(0)"
                    class="v2-retailer-cart__brand-product-link"
                    @click.stop="removeItem"
                    >Удалить из заказа</a
                >
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import getNameById from '@/mixins/getNameById'
import getFormattedNum from '@/utils/getFormattedNum'

export default {
    name: 'CartListItem',
    mixins: [getNameById],
    props: {
        product: {
            type: Object,
            default: () => {}
        },
        brand: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            changeTimer: null,
            quantity: this.product.pivot.Quantity,
            comment: this.product.pivot.Comment,
            isCommentOpen: !!this.product.pivot.Comment
        }
    },
    computed: {
        ...mapState('other', ['priceUnitOptions']),
        productID() {
            return this.product.ItemID
        }
    },
    watch: {
        quantity: function(val) {
            if (val >= 1) {
                this.changeCartInfo()
            } else {
                this.removeItem()
            }
        },
        comment: function(val) {
            if (val.length > 255) {
                this.comment = val.slice(0, 255)
            }
        }
    },
    methods: {
        ...mapActions('cart', ['deleteFromCart']),
        getFormattedNum,
        changeCartInfo() {
            if (this.changeTimer) {
                clearInterval(this.changeTimer)
            }

            this.changeTimer = setTimeout(() => {
                this.$emit('onChangeItem', {
                    productID: this.productID,
                    quantity: this.quantity,
                    comment: this.comment
                })
            }, 1000)
        },
        removeItem() {
            this.$emit('onRemoveItem', this.productID)
        },
        goToProduct() {
            this.$router.push({
                name: 'RetailerCatalogProductID',
                params: { id: this.product.ItemID }
            })
        },
        openComment() {
            this.isCommentOpen = true
        },
        increaseQuantityInCart() {
            this.quantity++
        },
        decreaseQuantityInCart() {
            if (this.quantity > 1) {
                this.quantity--
            } else {
                this.removeItem()
            }
        },
        onInCartQuantityInput(e) {
            let val = e.target.value
            this.quantity = parseInt(val.replace(/\D/g, '') || 0)
            e.target.value = this.quantity
        }
    }
}
</script>
